import React, { useEffect, useState } from "react";
import { GlobalWorkerOptions, getDocument } from "pdfjs-dist";

// Use CDN worker to avoid Webpack issues
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.min.js`;

const PDFViewer = ({ url }) => {
  const [pages, setPages] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    const renderPDF = async () => {
      try {
        const loadingTask = getDocument(url);
        const pdf = await loadingTask.promise;
        const renderedPages = [];

        for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
          const page = await pdf.getPage(pageNum);
          const viewport = page.getViewport({ scale: 1.5 });

          const canvas = document.createElement("canvas");
          const context = canvas.getContext("2d");
          canvas.width = viewport.width;
          canvas.height = viewport.height;

          await page.render({ canvasContext: context, viewport }).promise;

          renderedPages.push(canvas.toDataURL()); // Convert to image
        }

        setPages(renderedPages);
      } catch (err) {
        console.error("PDF render error:", err);
        setError("Failed to load PDF.");
      }
    };

    if (url) renderPDF();
  }, [url]);

  return (
    <div
      style={{
        height: "100%",
        overflowY: "auto",
        padding: "16px",
        backgroundColor: "#f5f5f5",
      }}
    >
      {error ? (
        <div>{error}</div>
      ) : (
        pages.map((src, index) => (
          <img
            key={index}
            src={src}
            alt={`Page ${index + 1}`}
            style={{
              width: "100%",
              marginBottom: "16px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderRadius: "8px",
            }}
          />
        ))
      )}
    </div>
  );
};

export default PDFViewer;
